import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TenantGroupDto } from '@flexyoo/api/models';
import { Pager } from '@flexyoo/shared/models';
import {
  COMMON_LIST_OPTIONS,
  CommonListColumn,
  CommonListColumnDirective,
  CommonListComponent,
  CommonListOptions,
  ImpersonateButtonComponent,
  TableItemActionsComponent,
} from '@flexyoo/shared/ui';
import { TranslateModule } from '@ngx-translate/core';
import { TenantGroupFormDialogAction } from '../../declarations/types/tenant-group-form-dialog-action.type';
import { TenantGroupsFilterComponent } from '../tenant-groups-filter/tenant-groups-filter.component';
import { TenantGroupsTableDataSourceService } from './tenant-groups-table-data-source.service';

@Component({
  selector: 'app-tenant-groups-table',
  templateUrl: './tenant-groups-table.component.html',
  styleUrl: './tenant-groups-table.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TenantGroupsFilterComponent,
    CommonListComponent,
    CommonListColumnDirective,
    TableItemActionsComponent,
    ImpersonateButtonComponent,
    TranslateModule,
    MatButtonModule,
  ],
  providers: [
    {
      provide: COMMON_LIST_OPTIONS,
      useValue: {
        columnTitlePrefix: 'admin.tenant-groups.table.headers',
        contextMenuSelector: 'contextMenuActions',
      } as CommonListOptions,
    },
  ],
})
export class TenantGroupsTableComponent {
  public dataSource = input<TenantGroupsTableDataSourceService>();
  public readonly onItemAction = output<{
    action: TenantGroupFormDialogAction;
    item: TenantGroupDto;
  }>();

  protected readonly columns: CommonListColumn[] = [
    {
      id: 'Name',
    },
    {
      id: 'TenantCount',
      type: { kind: 'number' },
    },
    {
      id: 'Actions',
      type: {
        kind: 'template',
        selector: 'actions',
      },
      unsetMaxWidth: true,
    },
  ];

  protected onPagerChanged(pager: Pager) {
    this.dataSource().setPager(pager);
  }

  protected createTenantGroup(): void {
    this.onItemAction.emit({ action: 'create', item: null });
  }
}
